export const MODEL = {
  PROFILE: 'user/profile',
  ESTABLISHMENT: 'establishment',
  USER: 'user',
  TEMPLATE: 'template',
  VARIABLE: 'variable',
};
